import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import InputNumber from '../common/input-number'

type InputNumberProps<IFormValues extends FieldValues> = {
    label?: string
    hideLabel?: boolean
    name: Path<IFormValues>
    required?: boolean
    step: string
    unit?: string
    disabled?: boolean
    control: Control<IFormValues, any>
    maxDecimalPlaces?: number
    inputClassName?: string
}

const ControlledInputNumber = <IFormValues extends FieldValues>({
    label,
    hideLabel,
    required = false,
    step,
    unit,
    name,
    disabled,
    control,
    maxDecimalPlaces: maxDecimal,
    inputClassName,
}: InputNumberProps<IFormValues>) => {
    // const debouncedOnChange = debounce((value: number | null, field: ControllerRenderProps<IFormValues>) => field.onChange(value), changeDebounce)
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <InputNumber
                    label={label}
                    hideLabel={hideLabel}
                    required={required}
                    step={step}
                    disabled={disabled}
                    unit={unit as string}
                    error={fieldState.error?.message as any}
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                    onBlur={field.onBlur}
                    maxDecimalPlaces={maxDecimal}
                    inputClassName={inputClassName}
                />
            )}
        />
    )
}

export default ControlledInputNumber
